import React, { useEffect, useReducer, useState } from "react"
import AddNewRevenueCodes from "./AddNewRevenueCodes"
import { ServerRequestProtected } from "../../../../utils/ServerDataRequest"
import NotificationHandler from "../../../../utils/NotificationHandler"
import { enumUtil } from "../../../../utils/Enum"
import Loader from "../../../shared/Loader/Loader"
import Pagination from "../../../shared/Pagination/Pagination"
import Table from "../../Shared/Table"
import SearchHeader from "../../Shared/SearchHeader"
import GridColumnHeader from "../../Shared/GridColumnHeader"
import handleCopyText from "../../../shared/CopyData"
import MasterList from "../../Shared/MasterList"
import isNull from "../../../../utils/NullChecking"
import { connect } from "react-redux"
import usePagination from "../../../../customhooks/usePagination"
import { FindSecondChild } from "../../../../utils/FindMenuOption"
const RevenueCodes = (props) => {
    const API_URL = enumUtil.controller.General
    const { type, Settings } = { ...props }
    const { paginationSection, PerPage, PageNo, TotalPages, handlePageClick, PreviousPage, NextPage, handleFingByCreteria, setTotalPages, handleSelectData } = usePagination(Settings.PaginationDefaultRows);
    let IsEditAllowed = FindSecondChild('Setup', 'Codes', 'Revenue')?.IsAdd

    const [isOpenRevenue, setisOpenRevenue] = useState(false)
    const [RevenueCodeData, setRevenueCodeData] = useState([]);
    const [RevenueCode, setRevenueCode] = useState();
    const [searchParam, setSearchParam] = useState();
    const [EnterParam, setEnterParam] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [isClose, setIsClose] = useState();
    const [show, setShow] = useState(false);
    const [totalCounts, setTotalCounts] = useState(false)
    const [isOpenMasterList, setisOpenMasterList] = useState(false)
    const searchButton = {
        AddNew: true,
        Excel: false,
        PDF: false,
        Delete: false,
        Filter: false,
        View: false,
        masterListButton: true,    // set true if want to display cards as well
    }

    ////////====GridColumnHeader=========//////////
    const [gridHeader, handleGridHeader] = useReducer((prev, next) => {
        return { ...prev, ...next }
    }, { defaultData: '', activeSortIcon: '' })
    //////////////////////////////////////////////
    //For Pagination
    // const [PerPage, setPerPage] = useState(Settings?.PaginationDefaultRows);
    // const [PageNo, setPageNo] = useState(1);
    // const [TotalPages, setTotalPages] = useState();
    const [searchParamType, setSearchparamType] = useState("");
    // const handlePageClick = (page) => { setPageNo(page); }
    // const PreviousPage = () => { if (PageNo > 1) setPageNo(PageNo - 1); }
    // const NextPage = () => { if (PageNo < TotalPages) setPageNo(PageNo + 1); }
    // const handleFingByCreteria = (e) => {
    //     setPerPage(e.target.value)
    //     setPageNo(1)
    // }
    // const handleSelectData = (data) => {
    //     setPerPage(data.value)
    //     setPageNo(1)
    // }
    ///////////
    const LoadData = (param, types) => {
        setIsLoading(true)
        setRevenueCodeData([])
        if (types) {
            setSearchparamType(types)
        } else {
            setSearchparamType("")
        }
        const SearchPageNo = !param
        ServerRequestProtected(API_URL + "/FindBySingleCriteria", 'post', {
            "TableName": enumUtil.enumAPITableName.RevenueCode,
            "SearchParam": param,
            "PerPage": PerPage,
            "PageNo": SearchPageNo ? PageNo : 1,
        }).then((response) => {
            setTotalCounts(response.Rows.length)
            setIsLoading(false)
            handleGridHeader({ defaultData: response.Rows })
            setRevenueCodeData(response.Rows)
            setTotalPages(response.count.NumOfPages);
            if (type && type === "Wizard") {
                if (response.Rows?.length == 0 && isNull(searchParamType)) {
                    setisOpenRevenue(true)
                }
            }
        }).catch((error) => {
            setTotalCounts(0)
            setIsLoading(false)
            if (type && type === "Wizard") {
                if (RevenueCodeData?.length == 0 && isNull(searchParamType)) {
                    setisOpenRevenue(true)
                }
            }
        })
    }

    const SearchByParam = () => {
        if (!isNull(searchParam)) {
            // setPageNo('1')
            LoadData(searchParam)
        } else {
            LoadData()
        }
    }
    const SearchOnEnter = (e) => {
        if (e.key === "Enter") {
            SearchByParam(searchParam, "searchParam")
        }
    }

    useEffect(() => {
        LoadData(searchParam);
    }, [PerPage, PageNo, isClose])
    const AddRevenue = (ID) => {
        setisOpenRevenue(true)
        setRevenueCode(ID)
    }
    const CloseRevenue = () => {
        setisOpenRevenue(false)
    }
    const DeleteRevenue = () => {
        setisOpenRevenue(false)
        setIsClose((Math.random()));
    }

    const handleRowSelection = (row) => {
        // console.log(row);
    }
    const [copiedText, setCopiedText] = useState({});


    const handleCopy = (row, type) => {
        let name = `${row}-${type}`;
        console.log("Name", name)
        handleCopyText(type);
        setCopiedText({ ...copiedText, [name]: true });
        setTimeout(() => {
            setCopiedText({ ...copiedText, [name]: false });
        }, 300)
    }



    const columns = [

        {
            key: 'RevenueCode',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Revenue Code'} sortIcon={true} type={'number'} colKey={'RevenueCode'} data={RevenueCodeData} setData={setRevenueCodeData} />),
            renderCell: ({ row }) => {
                // console.log(row)
                return (
                    <button className="btn btn-link w-100 p-0" >
                        <div className="d-flex copy_icon_hover justify-content-between w-100 align-items-center copy_icon gap-1">
                            <div className="validation_message" onClick={() => AddRevenue(row.RevenueCodeID)}>{row.RevenueCode} </div>
                            <div className="icon_copy">
                                <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.RevenueCodeID, row.RevenueCode)}></i>
                                <p class="tool_tip xsm_text text-light">Copy</p>
                            </div>
                            {copiedText[`${row.RevenueCodeID}-${row.RevenueCode}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
                        </div>
                    </button>
                );
            },
        },
        {
            key: 'Description',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Description'} sortIcon={true} type={'string'} colKey={'Description'} data={RevenueCodeData} setData={setRevenueCodeData} />),
            renderCell: ({ row }) => {
                return (
                    <>
                        <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
                            <div className="copy_icon validation_message">
                                {row.Description}
                            </div>
                            <div className="icon_copy">
                                <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.RevenueCodeID, row.Description)}></i>
                                <p class="tool_tip xsm_text text-light">Copy</p>
                            </div>
                            {copiedText[`${row.RevenueCodeID}-${row.Description}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
                        </div>
                    </>
                );
            }
        },
        {
            key: 'FullDescription',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Full Description'} sortIcon={true} type={'string'} colKey={'FullDescription'} data={RevenueCodeData} setData={setRevenueCodeData} />),
            flex: 1,
            renderCell: ({ row }) => {
                return (
                    <>
                        <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
                            <div className="copy_icon validation_message">
                                {row.FullDescription}
                            </div>
                            <div className="icon_copy">
                                <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.RevenueCodeID, row.FullDescription)}></i>
                                <p class="tool_tip xsm_text text-light">Copy</p>
                            </div>
                            {copiedText[`${row.RevenueCodeID}-${row.FullDescription}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
                        </div>
                    </>
                );
            }
        },
        {
            key: 'UpdatedBy',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Updated By'} sortIcon={true} type={'string'} colKey={'UpdatedBy'} data={RevenueCodeData} setData={setRevenueCodeData} />),
            resizable: true,
        },
        {
            key: 'UpdatedDate',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Updated Date'} sortIcon={true} type={'string'} colKey={'UpdatedDate'} data={RevenueCodeData} setData={setRevenueCodeData} />),
            resizable: true,
            renderCell: ({ row }) => {
                return (
                    <>
                        <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
                            {row.UpdatedDate}
                        </div>
                    </>
                );
            }
        },
    ]
    let PopupScreen = "";
    if (isOpenRevenue) {
        PopupScreen = <AddNewRevenueCodes isOpenRevenue={isOpenRevenue} onClose={CloseRevenue} onDeleteRevenue={DeleteRevenue} RevenueCode={RevenueCode} type={type} />
    }
    const handleMasterList = () => {
        setisOpenMasterList(true)
    }
    const CloseMasterList = (ID) => {
        setisOpenMasterList(false)
        // setPOSCode(ID) 
    }
    let PopupScreenMasterList = "";
    if (isOpenMasterList) {
        PopupScreenMasterList = <MasterList isOpen={isOpenMasterList} onClose={CloseMasterList} LoadData={LoadData} GridTableName={'MasterListRevenueCode'} SaveTableName={'MASTERLISTREVENUECODE'} type={type} Name={"RevenueCode"} IsEditAllowed={IsEditAllowed} />
    }
    const CardView = () => setShow(true);
    const TableView = () => setShow(false);
    const rowClass = () => { return "row-bg" }
    const handleExcel = () => { }
    const handlePdf = () => { }
    const handleFilter = () => { }
    const handleDelete = () => { }
    const handleClearSearch = () => {
        setSearchParam('')
    }
    const RevenueCodesBody = () => {
        return (<>
            <div className='container-fluid action-row br-clr'>
                <div className="row justify-content-between">
                    <div className="col-4">
                        <div className="input">
                            <div className='input-group hk-input-search'>
                                <input type="text" className='form-control fc-xs'
                                    placeholder='Search by Revenue code or Description...'
                                    onChange={e => setSearchParam(e.target.value)}
                                    onKeyDown={SearchOnEnter}
                                    value={searchParam}
                                />

                                {searchParam?.length > 0 ?
                                    <span className="input-group-text" id="basic-addon2" onClick={handleClearSearch}>
                                        <i className="bi bi-x"></i>
                                    </span> : <span className="input-group-text" id="basic-addon2" onClick={SearchByParam}>
                                        <i className="bi bi-search"></i>
                                    </span>}
                            </div>
                        </div>
                    </div>
                    <div className="col-8 ps-0">
                        <SearchHeader
                            AddNew={AddRevenue}
                            Excel={handleExcel}
                            PDF={handlePdf}
                            Delete={handleDelete}
                            Filter={handleFilter}
                            cardView={CardView}
                            tableView={TableView}
                            masterListButton={handleMasterList}
                            show={show}
                            searchButton={searchButton}
                            Key={634}
                            Name={'Revenue Codes'}
                            Counts={totalCounts}
                        />
                    </div>
                </div>
            </div>
            {show === false ?
                <Table
                    columns={columns}
                    rows={RevenueCodeData}
                    height='500px'
                    rowClass={rowClass}
                    // dynamicClass= 'fill-grid DataGrid-Table hk-exp-table'
                    dynamicClass='fill-grid DataGrid-Table hk-exp-table insurance_code_table'
                    rowHeight={25}
                    PerPage={PerPage}
                    PageNo={PageNo}
                    TotalPages={TotalPages}
                    handlePageClick={handlePageClick}
                    PreviousPage={PreviousPage}
                    handleFingByCreteria={handleFingByCreteria}
                    NextPage={NextPage}
                    Key={634}
                    Name={'Revenue Codes'}
                    isLoading={isLoading}
                    TableName={'RevenueCode'}
                    handleSelectData={handleSelectData}
                    LoadData={() => LoadData(searchParam)}
                    ClearSearch={handleClearSearch}
                /> : null
            }
        </>)
    }
    // useEffect(()=>{
    //     if(type && type === "Wizard"){
    //         if(RevenueCodeData?.length == 0 && isNull(searchParamType)){
    //             setisOpenRevenue(true)
    //         }
    //     }
    // },[RevenueCodeData, searchParamType])
    return (
        <React.Fragment>
            {isLoading ? <Loader /> : null}
            {type && type === "Wizard" ?
                <>
                    {/* {RevenueCodeData?.length > 0 || !isNull(searchParamType) ? */}
                    <>
                        {isOpenRevenue ? <>{PopupScreen}</> : isOpenMasterList ? <>{PopupScreenMasterList}</> : <>{RevenueCodesBody()}</>}
                    </>
                    {/* : <>{PopupScreen}</> */}
                    {/* } */}
                </> :
                <>
                    {PopupScreen}
                    {PopupScreenMasterList}
                    {RevenueCodesBody()}
                </>
            }

        </React.Fragment>
    )
}
const mapStateToProps = (state) => {
    return {
        Settings: state.SettingsReducer,
    }
}
export default connect(mapStateToProps)(RevenueCodes)